import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import TextArea from "../src/components/textArea/TextArea";
import styled from "styled-components";
import Colors from "../src/constants/Colors";
import {deviceMax} from '../styles/device';
import WaveLayout from '../src/layouts/WaweLayout';
import {NavigationURLs} from "../src/functions/NavigationFunctions";
import GeneralBreadcrumb from "../src/components/breadcrumb/GeneralBreadcrumbComp";

const Uyelik: NextPage = () => {
    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Üyelik Sözleşmesi'}
    ];

    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Uyelik Sözleşmesi | Pembe Panjur'}
                description={'Pembe Panjur uyelik sözleşmesi ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false}
                        hamburgerMenuType={'black'} registerButton={true}>
                <MemberShipWrapper>
                    <TextArea className={'mobile-plr0'}>
                        <GeneralBreadcrumb items={breadcrumbItems} margin={false} colorProps={false}/>
                        <h2>Pembe Panjur Üyelik Sözleşmesi</h2>
                        <p style={{fontWeight: 'bold'}}>
                            Değerli Ziyaretçimiz, <br/>
                            Aşağıdaki, Pembepanjur.com ile Pembepanjur.com üyesi arasındaki üyelik sözleşmesinin
                            metnidir. Pembepanjur.com'a üye olmadan önce lütfen bu sözleşmeyi dikkatle okuyunuz ve
                            sözleşmenin içerdiği tüm maddeleri onaylamadan siteye üyeliğinizi tamamlamayınız. Yeni
                            üyelik esnasında, bu metni okuduğunuzu söyleyen bir kutucukla karşılaşacaksınız; bu kutucuğu
                            işaretlemeniz, aşağıdaki maddelerin tamamını kabul ettiğiniz anlamına gelecektir.
                        </p>

                        <h3>
                            PEMBEPANJUR.COM İNTERNET SİTESİ ÜYELİK SÖZLEŞMESİ
                        </h3>

                        <ol style={{paddingLeft: 17}}>
                            <li className={'listMarkerPink'}>
                                Taraflar
                                <p>
                                    İşbu sözleşme, sitenin sahibi ve işletmecisi olan Pembepanjur.com ile üye olan kişi
                                    arasında düzenlenmiş, elektronik ortamda üye tarafından onaylanması anında
                                    akdedilmiş ve karşılıklı olarak yürürlülüğe girmiştir.
                                </p>
                            </li>
                            <li className={'listMarkerPink'}>
                                Tanımlar
                                <p>
                                    Site:www.pembepanjur.com adresinde yayın yapan internet sitesini.
                                    Üye:www.pembepanjur.com adresinde yer alan formu doldurmuş, "Üyelik Sözleşmesi'ni
                                    okudum. Orada yazılanları aynen kabul ediyorum." ifadesinin başındaki kutucuğu
                                    işaretlemiş ve ‘’ Ileri veya Kaydet ve Devam et veya Kaydet ve Çık veya Gönder veya
                                    Devam vb.” butonuna basarak üye olma sürecini tamamlamış kişi.
                                    Üye profili : www.pembepanjur.com adresinde uyenin kendisinin verdiği bilgilerle
                                    oluşturulan, Üyelik Bilgileri, Temel bilgiler, Yaşam tarzı, Kendi kelimeleriyle
                                    başlıklarından ve üyenin kendisi tarafından eklenen fotoğraftan oluşan, diğer üyeler
                                    tarafından görüntülenebilen Üyeye özel tanıtım sayfası.
                                </p>
                            </li>
                            <li className={'listMarkerPink'}>
                                Sözleşmenin Konusu
                                <p>
                                    İşbu sözleşmenin konusu, sitede sunulan hizmetlerin, bu hizmetlerden yararlanma
                                    şartlarının ve tarafların hak ve yükümlülüklerinin tespitidir. İşbu sözleşmenin
                                    kapsamı işbu sözleşme ile site içerisinde yer alan kullanıma, üyeliğe ve hizmetlere
                                    ilişkin Pembepanjur.com tarafından yapılmış olan bilcümle uyarı, yazı ve açıklama
                                    gibi beyanlardır. Üye, işbu sözleşme hükümlerini kabul etmekle, site içinde yer alan
                                    kullanıma, üyeliğe ve hizmetlere ilişkin Pembepanjur.com tarafından açıklanan her
                                    türlü beyanı da kabul etmiş olmaktadır. Üye bahsi geçen beyanlarda belirtilen her
                                    türlü hususa uygun olarak davranacağını kabul, beyan ve taahhüt eder.
                                </p>
                            </li>
                            <li className={'listMarkerPink'}>
                                Hak ve Yükümlülükler:
                                <ul>
                                    <li className={'listMarkerBold'}>
                                        <span style={{marginRight: 20, color: `${Colors.brandColor}`}}>
                                        4.1.
                                        </span>
                                        <span>
                                            Üyelerin Hak ve Yükümlülükleri
                                        </span>
                                        <p>
                                            Üye, üyeliği süresince, sitenin hizmetlerinden faydalanırken ve sitenin
                                            hizmetlerle ilgili herhangi bir işlemi yerine getirirken işbu sözleşme
                                            içerisinde yer alan tüm şartlara, sitenin ilgili yerlerinde belirtilen
                                            kurallara ve yürürlükteki tüm mevzuata uygun hareket edeceğini, işbu
                                            sözleşme ile belirlenen tüm şart ve kuralları anladığını, kabul ettiğini ve
                                            onayladığını kabul eder.
                                        </p>
                                        <p>
                                            Siteye üye olabilmek için reşit olmak, işbu sözleşme hükümleri uyarınca
                                            üyeliği daha önceden iptal edilmemiş olmak gerekmektedir.. Reşit olmayan,
                                            üyeliği daha önce iptal edilmiş olan kişilerin üyelik kayıt işlemlerini
                                            tamamlamış olmaları ve işbu sözleşmeyi onaylamaları, üyelik sonucunu
                                            doğurmayacaktır. Üye, üyelik aşamasında ilgili internet sayfası aracılığıyla
                                            belirttiği ve "Ay, Gün, Yıl"dan oluşan doğum tarihi ile reşit olduğunu beyan
                                            etmiş olur. Reşit olmadığı, üyeliğinin daha önce iptal edilmiş olduğu tespit
                                            edilen üyenin üyeliği iptal edilir.Üyenin vermiş olduğu yanlış beyandan
                                            dolayı sitenin herhangi bir sorumluluğu yoktur.
                                        </p>
                                        <p>
                                            Üye,Pembepanjur.com 'un yürürlükteki emredici mevzuat hükümleri gereğince
                                            resmi makamlara açıklama yapmakla yükümlü olduğu durumlar içersinde, resmi
                                            makamlarca usulü dairesinde bu bilgilerin talep edilmesi halinde üyelere ait
                                            gizli/özel/ticari bilgileri resmi makamlara açıklamaya yetkili olacağını ve
                                            bu sebeple Pembepanjur.com’dan her ne nam altında olursa olsun tazminat
                                            talep edilemeyeceğini kabul ve taahhüt eder.
                                        </p>
                                        <p>
                                            Üyelerin, site aracılığıyla Pembepanjur.com tarafından sunulan hizmetlerden
                                            yararlanabilmek amacıyla kullandıkları sisteme erişim araçlarının (kullanıcı
                                            ismi, şifre v.b) güvenliği, saklanması, üçüncü kişilerin bilgisinden uzak
                                            tutulması, kullanılması durumlarıyla ilgili hususlar tamamen üyelerin
                                            sorumluluğundadır. Üyelerin, sisteme giriş araçlarının güvenliği,
                                            saklanması, üçüncü kişilerin bilgisinden uzak tutulması, kullanılması gibi
                                            hususlardaki tüm ihmal ve kusurlarından dolayı üyelerin ve/ veya üçüncü
                                            kişilerin uğradığı veya uğrayabileceği zararlardan Pembepanjur.com’un
                                            doğrudan veya dolaylı herhangi bir sorumluluğu yoktur.
                                        </p>
                                        <p>
                                            Üyeler sitedeki ilgili bölümlere ve üye profillerine kendileri tarafından
                                            sağlanan bilgilerin ve içeriklerin doğru ve hukuka uygun olduğunu kabul ve
                                            taahhüt etmektedirler. Pembepanjur.com, üyeler tarafından siteye iletilen
                                            veya üye profillerinin oluşturulmasında ve değiştirilmesinde kendileri
                                            tarafından yüklenen, değiştirilen ve sağlanan bilgilerin ve içeriklerin
                                            doğruluğunu araştırma; bu bilgi ve içeriklerin güvenli, doğru, işbu
                                            sözleşmenin hükümlerine ve hukuka uygun olduğunu taahhüt ve garanti etmekle
                                            yükümlü ve sorumlu olmadığı gibi söz konusu bilgi ve içeriklerin yanlış veya
                                            hatalı olmasından ve/veya bu içerikler aracılığıyla diğer internet
                                            sitelerine yapılan yönlendirmelerden dolayı ortaya çıkacak hiçbir
                                            maddi-manevi zarardan da sorumlu tutulamaz.

                                        </p>
                                        <p>
                                            Üye profilinde kişisel iletişim bilgileri (e-posta adresi, ikamet adresi,
                                            telefon numarası vb.) bulunamaz; Pembepanjur.com 'un üye profilinde kişisel
                                            iletişim bilgileri bulunan üyelerin üyeliklerini iptal etme hakkı
                                            bulunmaktadır. Üye profilinde bulunan bilgiler, sitenin diğer tüm üyeleri
                                            tarafından görülebilir; üye bu bilgilerin görüntülenmemesini talep edemez.
                                            Üye profilinde bulunan bilgilerin görüntülenmesine ancak üyeliğin iptal
                                            edilmesi ile son verilir.

                                        </p>
                                        <p>
                                            Üyeler, Pembepanjur.com 'un yazılı onayı olmadan işbu sözleşmeyi veya bu
                                            sözleşmenin kapsamındaki hak ve yükümlülüklerini, üye profillerini, üye
                                            bilgilerini kısmen veya tamamen herhangi bir üçüncü kişiye devredemez;
                                            üyelik üyenin kendisinden başka kişilerin kullanımına açılamaz. Bu tür
                                            devirler veya yetkisiz kullanımlar sonucu üçüncü kişilerin uğradıkları veya
                                            uğrayabilecekleri zararlardan dolayı Pembepanjur.com doğrudan ve/veya
                                            dolaylı olarak hiçbir şekilde sorumlu tutulamaz. Üyeliğini başkasına
                                            kullandırttığı veya devrettiği tespit edilen üyenin üyeliği iptal edilir.

                                        </p>
                                        <p>
                                            Üyelerin, kendi aralarında site aracılığıyla yaptıkları özel mesajlaşmalar
                                            da dahil olmak üzere sitede yaptıkları her işlem ve eylemdeki hukuki ve
                                            cezai sorumluluk kendilerine aittir,hiçbir şekilde sitenin sorumluluğu
                                            cihetine gidilemez. İşbu sebeple Pembepanjur.com'un uğrayabileceği her türlü
                                            zarara karşılık sitenin üyeye rücu hakkı vardır.

                                        </p>
                                        <p>
                                            Üye diğer üyelere, reklam ya da ticari amaçlar taşıyan mesajlar gönderemez,
                                            diğer üyeleri bir başka internet sitesine yönlendiremez. Bu tür mesajlar
                                            ileten üyenin mesajlaşma hakkı kısıtlanabilir ya da üyeliği iptal
                                            edilebilir.

                                        </p>
                                        <p>
                                            Üyenin yaptığı mesajlaşmaların toplamı Pembepanjur.com 'un belirlediği ve
                                            sitenin ilgili bölümünde bildirdiği sayıdan fazla ise, mesajlar en eski
                                            tarihten başlanarak silinebilir. Üye Pembepanjur.com 'un belirlediği ve
                                            sitenin ilgili yerinde bildirdiği süre boyunca giriş yapmadıysa (log-in
                                            olmadıysa) tüm mesajları silinebilir.

                                        </p>
                                        <p>
                                            Her üye, Pembepanjur.com'da bulunan resimleri, metinleri, görsel ve işitsel
                                            imgeleri, video klipleri, dosyaları, veritabanları, katalogları ve listeleri
                                            çoğaltmayacağını, kopyalamayacağını, dağıtmayacağını, işlemeyeceğini, gerek
                                            bu eylemleri ile gerekse de başka yollarla Pembepanjur.com ile doğrudan
                                            ve/veya dolaylı olarak rekabete girmeyeceğini kabul ve taahhüt etmektedir.
                                            Üyelerin işbu sözleşme hükümlerine ve hukuka aykırı olarak
                                            gerçekleştirdikleri site üzerindeki faaliyetleri nedeniyle üçüncü kişilerin
                                            uğradıkları veya uğrayabilecekleri zararlardan dolayı Pembepanjur.com
                                            doğrudan ve/veya dolaylı olarak hiçbir şekilde sorumlu tutulamaz.

                                        </p>
                                        <p>
                                            Üye, sitenin bilgi@pembepanjur.com adresine "iptal talebi" başlıklı mesaj
                                            atarak üyeliğini iptal ettirebilir.

                                        </p>
                                        <p>
                                            Üye, site aracılığıyla diğer üyelere gönderdiği özel mesajlarda ve siteye
                                            yüklediği resimlerde toplumsal ahlaka, genel nezaket kurallarına aykırı
                                            ifadeler kullanmayacağını kabul ve taahhüt eder. Özel mesajlar otomatik
                                            programlar ile taranabilir veya mesaj gönderilen Üyelerin şikayeti üzerine
                                            incelenebilir. Bu otomatik tarama sonucunda veya şikayet sonrasında yapılan
                                            incelemede gerekli görüldüğü takdirde üyenin profili yayından
                                            kaldırılabilir, mesajlaşma hakkı kısıtlanabilir, bütünüyle engellenebilir
                                            veya üyeliği tamamen iptal edilebilir.

                                        </p>
                                        <p>
                                            PembePanjur.com üyeliği bireysel üyelik olup, üçüncü şahıslara ya da tüzel
                                            kişilere devredilemez, emanet verilemez. Bu durumun tespiti halinde üyelik
                                            iptal edilir. Bu tip hareketlerin doğuracağı sonuçlardan PembePanjur.com
                                            sorumlu tutulamaz.
                                            Sağlanan hizmetten memnun kalmayan üyelere ücret iadesi talep etmeleri
                                            halinde ücretleri iade edilir.

                                        </p>
                                        <p>
                                            Kredi kartı ya da cep telefonu ile aylık, 3 aylık, 6 aylık abone olan üyeler
                                            istedikleri zaman "hesap" sayfasından otomatik ödemelerini kapatıp
                                            aboneliğin iptalini sağlayabilirler.

                                        </p>
                                        <p>
                                            Genel ahlaka aykırı davranışlar sebebiyle üyeliği iptal edilen Gold ve
                                            benzeri ücretli üyelere ücret iadesi yapılmaz.

                                        </p>
                                    </li>
                                    <li className={'listMarkerBold'}>
                                        <span style={{marginRight: 20, color: `${Colors.brandColor}`}}>
                                        4.2.
                                        </span>
                                        <span>
                                            Pembepanjur.com 'un Hak ve Yükümlülükleri
                                        </span>
                                        <p>
                                            Pembepanjur.com, sitede sunulan hizmetleri ve içerikleri her zaman
                                            değiştirebilme; üyelerin sisteme yükledikleri bilgileri, içerikleri ve üye
                                            profillerini, üyeler de dahil olmak üzere üçüncü kişilerin erişimine
                                            kapatabilme ve silme hakkını saklı tutmaktadır. Pembepanjur.com bu hakkını
                                            hiçbir bildirimde bulunmadan ve önel vermeden kullanabilir. Üyeler,
                                            Pembepanjur.com 'un talep ettiği değişiklik ve/veya düzeltmeleri ivedi
                                            olarak yerine getirmek zorundadırlar. Pembepanjur.com tarafından talep
                                            edilen değişiklik ve/veya düzeltme istekleri gerekli görüldüğü takdirde
                                            bizzat Pembepanjur.com tarafından yapabilir. Pembepanjur.com tarafından
                                            talep edilen değişiklik ve/veya düzeltme taleplerinin, üyeler tarafından
                                            zamanında yerine getirilmemesi sebebiyle doğan veya doğabilecek zararlar,
                                            hukuki ve cezai sorumluluklar tamamen üyelerin kendilerine aittir.

                                        </p>
                                        <p>
                                            Site üzerindeki yönlendirmeler (link, banner) vasıtasıyla erişilen
                                            portallar, web siteleri, dosyalar ve içerikler, bu linkler vasıtasıyla
                                            erişilen portallar veya web sitelerinden sunulan hizmetler veya ürünler veya
                                            bunların içeriği hakkında Pembepanjur.com 'un herhangi bir sorumluluğu
                                            yoktur.

                                        </p>
                                        <p>
                                            Pembepanjur.com, sitede yer alan üye bilgilerini, üye profillerini ve
                                            üyelerin sisteme yükledikleri bilgileri ve içerikleri, güvenlik, kendi
                                            yükümlülüğünü ifa ve bazı istatistiki değerlendirmeler için dilediği biçimde
                                            kullanabilir; bunları bir veritabanı üzerinde tasnif edip muhafaza edebilir.

                                        </p>
                                        <p>
                                            Pembepanjur.com, sitenin işleyişine, genel kurallarına, genel ahlak
                                            kurallarına aykırı ve Pembepanjur.com tarafından kabul edilmesi mümkün
                                            olmayan mesajları, içerikleri istediği zaman ve şekilde erişimden
                                            kaldırabilir; Pembepanjur.com bu mesaj ve içeriği giren üyenin üyeliğine
                                            herhangi bir ihbar yapmadan son verebilir. Üye Pembepanjur.com'a yüklediği
                                            ahlaka ve hukuka aykırı içerik sebebiyle Pembepanjur.com'un maruz kalacağı
                                            her türlü zararı tazmin etmekle yükümlüdür.

                                        </p>
                                        <p>
                                            Teknik sorunlardan dolayi "Site"nin yayınlarında kesintiler olabilir. Bu
                                            kesintilerden dolayı yaşanan iletişim ve "Site"ye ulaşmaya dair ilişkin
                                            kesintilerde "Üye"nin yaşayacağı sorunlardan " Pembepanjur.com " sorumlu
                                            tutulamaz.

                                        </p>
                                        <p>
                                            "Site"de yayınlanan ve "Üye" profillerinde yer alan her türlü görüntü, yazı,
                                            fotoğraf ve diğer materyal " Pembepanjur.com "un izni olmadan diğer internet
                                            sitelerinde ve gazete, televizyon, radyo, dergi gibi konvansiyonel
                                            mecralarda yayınlanamaz. "Site"de yer alan tüm içerik, Fikir ve Sanat
                                            Eserleri Kanunu'nun dördüncü maddesinin yedinci bendi olan, "Belli bir
                                            maksada göre ve hususi bir plan dahilinde verilerin ve materyallerin seçilip
                                            derlenmesi sonucu ortaya çıkan ve bir araç ile okunabilir veya diğer
                                            biçimdeki veri tabanları" ile koruma altında olduğu gibi eser niteliğindeki
                                            içerik ayrıca hukuki korumaya tabidir.

                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li className={'listMarkerPink'}>
                                Sınırlı Sorumluluk
                                <p>
                                    Pembepanjur.com, üyelerin veya üyelerin sitede sağlanan hizmetler ve/veya yer alan
                                    uygulamalar sebebiyle muhatap olduklari 3. kişilerin, bu hizmet ve uygulamalar ile
                                    bağlantılı olarak ve /veya kaynaklanan hiç bir maddi, manevi, dolaylı veya direkt
                                    zarardan sorumlu olmayacağı gibi, uyelerin kanuna aykırı fiil ve eylemlerinden
                                    dolayı hukuki ve cezai olarak sorumlu tutulamaz.

                                </p>
                            </li>
                            <li className={'listMarkerPink'}>
                                Mucbir Sebepler
                                <p>
                                    Hukuken mücbir sebep sayılan tüm durumlarda, Pembepanjur.com işbu sözleşme ile
                                    belirlenen edimlerinden herhangi birini geç veya eksik ifa etme veya ifa etmeme
                                    nedeniyle yükümlü değildir. Bu ve bunun gibi durumlar, Pembepanjur.com için,
                                    gecikme, eksik ifa etme veya ifa etmeme veya temerrüt addedilmeyecek veya bu
                                    durumlar için Pembepanjur.com 'dan herhangi bir nam altında tazminat talep
                                    edilemeyecektir. "Mücbir sebep" terimi, doğal afet, isyan, savaş, grev, iletişim
                                    sorunları, altyapı ve internet arızaları, elektrik kesintisi ve kötü hava koşulları
                                    da dahil ve fakat bunlarla sınırlı olmamak kaydıyla ilgili tarafın makul kontrolü
                                    haricinde ve Pembepanjur.com 'un gerekli özeni göstermesine rağmen önleyemediği
                                    kaçınılamayacak olaylar olarak yorumlanacaktır.

                                </p>
                            </li>
                            <li className={'listMarkerPink'}>
                                Uygulanacak Hukuk ve Yetki
                                <p>
                                    İşbu sözleşmenin uygulanmasında, yorumlanmasında ve bu sözleşme dahilinde doğan
                                    hukuki ilişkilerin yönetiminde Türk Hukuku uygulanacaktır. İşbu sözleşmeden dolayı
                                    doğan veya doğabilecek her türlü ihtilafın hallinde İstanbul Mahkemeleri ve İcra
                                    Daireleri yetkilidir.

                                </p>
                            </li>
                            <li className={'listMarkerPink'}>
                                Sözleşmenin Feshi
                                <ul style={{listStyle: 'lower-alpha'}}>
                                    <li className={'ml-0'}
                                        style={{color: `${Colors.black}`, fontWeight: "bold", marginRight: 20}}>
                                        <span style={{fontWeight: 400}}>
                                        İşbu sözleşme üyenin üyeliği iptal edilinceye kadar yürürlükte kalacak ve
                                        taraflar arası hüküm ve sonuçlarını doğurmaya devam edecek, üyenin üyelik
                                        süresinin dolması geçici veya kalıcı olarak üyeliğinin durdurulması hallerinde
                                        sona ermiş sayılacaktır.
                                        </span>
                                    </li>
                                    <li className={'ml-0'} style={{color: `${Colors.black}`, fontWeight: "bold"}}>
                                        <span style={{fontWeight: 400}}>
                                            Pembepanjur.com, üyelerin işbu sözleşmede belirtilen hükümleri ve site içinde
                                        yer alan kullanıma, üyeliğe ve hizmetlere ilişkin benzeri kuralları ihlal
                                        etmeleri durumunda sözleşmeyi tek taraflı olarak feshedebilecek ve üyeler fesih
                                        sebebiyle Pembepanjur.com 'un uğradığı tüm zararları tazmin etmekle yükümlü
                                        olacaktır.
                                        </span>

                                    </li>
                                </ul>
                            </li>

                        </ol>

                    </TextArea>
                </MemberShipWrapper>
            </WaveLayout>
        </React.Fragment>

    )
}

const MemberShipWrapper = styled.div`
  position: relative;
  padding: 0 25px;
  margin-bottom: 44px;

  @media ${deviceMax.tablet} {
    padding: 70px 0 0 0;
    margin-bottom: 0;
  }

  > div {
    padding-left: 40px;
    padding-right: 40px;
  }
  
  h2 {
    margin-top: 0;
    text-transform: uppercase;
    color: ${Colors.brandColor};

    @media ${deviceMax.tablet} {
      color: ${Colors.black};
      text-align: center;
      margin: 0 auto 24px;
    }
  }

  .listMarkerPink {
    font-weight: bold;
    color: ${Colors.brandColor};

    p, span {
      margin-left: -17px;
      color: ${Colors.black};
    }

    &::marker {
      font-weight: bold;
      color: ${Colors.brandColor};
    }

    > ul {
      > .ml-0 {
        > span {
          margin-left: 0;
        }
      }
    }
  }

  .listMarkerBold {
    &::marker {
      font-weight: bold;
    }
  }
`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default Uyelik;
